<app-loading [active]="loading.isLoading"></app-loading>
<app-message [active]="!!errorMsg" [message]="errorMsg"/>

@if (!match.isDartsscorer) {
  <div class="font-italic">
    {{'NO_STATISTICS' | translate}}
  </div>
}

@if (!loading.isLoading && !errorMsg && statistics && match.isDartsscorer) {
  <div class="pb-2 md:pb-0 table-design">
    <app-spiel-scorer-ansicht [statisticsData]="statistics" [match]="match"/>
  </div>
}
